import { filter, Observable } from 'rxjs';
import { vacancyApiActions } from '@mkp/vacancy/state/actions';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { getVacancyById } from '@mkp/vacancy/state';
import { Vacancy } from '@mkp/vacancy/models';

export const vacancyFromStore = (vacancyId: string, store: Store): Observable<Vacancy> =>
  store.select(getVacancyById(vacancyId)).pipe(filter(Boolean));

export const vacancyLoadedFromGuard = (vacancyId: string, actions$: Actions) =>
  actions$.pipe(
    ofType(vacancyApiActions.loadVacancyFromGuardSuccess),
    filter(({ vacancy }) => vacancy.id === vacancyId)
  );

export const vacancyLoadFromGuardFailed = (vacancyId: string, actions$: Actions) =>
  actions$.pipe(
    ofType(vacancyApiActions.loadVacancyFromGuardFailure),
    filter((action) => action.vacancyId === vacancyId)
  );
